import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import './shards.css';
import { Redirect } from 'react-router';
import './Results.css';

import fire from './fire';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';

import {
  ShareButtons,
  ShareCounts,
  generateShareIcon,
} from 'react-share';

const {
  FacebookShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailShareButton,
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const TelegramIcon = generateShareIcon('telegram');
const WhatsappIcon = generateShareIcon('whatsapp');
const EmailIcon = generateShareIcon('email');

const database = fire.database();

let sessionKey;

let sessionId;

let resultsObj;







export default class Results extends React.Component {

	constructor(props) {
    	super(props);
    	this.state = {
      		results: [],
      		visible: true
    	}
    	
  	}


  	componentDidMount() {
  		let sessionKeys = this.props.location.pathname.slice(9);
  		let messagesRef = fire.database().ref('sessions/'+ sessionKeys).orderByKey();
    messagesRef.on('child_added', snapshot => {
      /* Update React state when message is added at Firebase Database */
      	let result = { description: snapshot.val().description, likedOne: snapshot.val().likedOne, likedTwo: snapshot.val().likedTwo, src: snapshot.val().src, title: snapshot.val().title, buyLink: snapshot.val().buyLink, id: snapshot.key };

      	if (result.likedOne == true && result.likedTwo == true) {
      		this.setState({ results: [result].concat(this.state.results) });
  		}
    })
	}


  	

	
	


	render() {

		const shareUrl = window.location.href;
    	const title = 'Check out our Pairful results';

		
		

	

		if (this.state.results.length != 0) {
			return (
				<div>
				<div className="bg-light">
					<div>
		 					<div className="row justify-content-center text-center bg-img1 align-items-center" style={{marginTop: 0}}>
				 				<div className="col-sm-12 col-md-8 col-lg-6" style={{marginTop: 0}}>
				 					
				    				<h3 className="display-4 text-light">{this.state.results.length != 0 ? 'Awesome' : 'Unlucky'} - you have {this.state.results.length} match{this.state.results.length != 1 ? 'es' : ''}!</h3>
				    				
				    			
				  				</div>
				  			</div>
				  			
				  	</div>
					<main role="main" className="container" style={{marginTop: 60}} id="share-results">
					<div className="row justify-content-between" style={{marginBottom: 40}}>
						<div className="col-sm-12 col-md-5"> 
							<p className="lead text-muted text-left" style={{marginBottom: 20}}>Both you and your partner would like to try out the following items...</p>
						</div>
						<div className="col-sm-12 col-md-4"> 
							<p className="small text-muted text-left" style={{marginBottom: 5}}>Your partner can see your shared results here: <a href={window.location.href}>{window.location.href}</a> or share via the buttons below...</p>
						</div>
					</div>
					<div className="row justify-content-end">
					<div className="col-sm-12 col-md-4" style={{marginBottom: 20}}> 
					<div className="row justify-content-center">
						<div className="col mx-auto">
							<div className="social-buttons mx-auto">
								<FacebookShareButton
					            url={shareUrl}
					            quote={title}
					            >
					            <FacebookIcon
					              size={32}
					              round />
					          </FacebookShareButton>
				          	</div>
		          
						</div>
						<div className="col">
							<div className="social-buttons mx-auto">
								<WhatsappShareButton
					            url={shareUrl}
					            title={title}
					            >
					            <WhatsappIcon
					              size={32}
					              round />
					          </WhatsappShareButton>
				          	</div>
		          
						</div>
						<div className="col">
							<div className="social-buttons mx-auto">
								<TelegramShareButton
					            url={shareUrl}
					            title={title}
					            >
					            <TelegramIcon
					              size={32}
					              round />
					          </TelegramShareButton>
				          	</div>
		          
						</div>
						<div className="col">
							<div className="social-buttons mx-auto">
								<EmailShareButton
					            url={shareUrl}
					            subject={title}
					            body={title}
					            >
					            <EmailIcon
					              size={32}
					              round />
					          </EmailShareButton>
				          	</div>
		          		</div>
		          		</div>
						</div>
					</div>

					
					
			      <div className="row justify-content-center">
					
			          { /* Render the list of messages */
			            this.state.results.map( result => (
			            	 

			            <div className="col-sm-12 col-md-6 col-lg-4" style={{marginTop: 15, marginBottom: 15}}>
			            <div className="card" key={result.id}>
			            	<h4 className="card-title text-muted" style={{marginBottom:"-20px", zIndex:'99', marginTop:10, marginRight:10, marginLeft:10, opacity:"0.8"}}><span className="float-right"><ModalExample description={result.description} buyLink={result.buyLink} cardTitle={result.title}/></span></h4>
			              <img id="image" className="card-img-top" src={result.src} alt="Card image cap" />
			              <div className="card-body">
			                <p className="card-title lead">{result.title}</p>
			                
			                <a href={result.buyLink} className="btn btn-block btn-lg btn-success">Buy Now!</a>
			              </div>
			            </div>
			            </div>
			      

			           ))
			          }
			        
					
					</div>
			      </main>
			      <footer className="text-muted bg-dark" style={{marginTop:50}}>

				      <div  style={{paddingTop:80, paddingBottom:40, paddingRight:20, paddingLeft:20}}>
				        <p className="float-right small">
				          <a href="http://www.louisnicholls.com" style={{color:'#c1c1c1'}}>&copy; Louis Nicholls 2017</a>
				          
				        </p>
				        <p className="float-left small">
				          <a href="https://unsplash.com/photos/AsahNlC0VhQ" style={{color:'#c1c1c1'}}>Photo by Everton Vila at Unsplash</a>
				          
				        </p>
				        
				      </div>
				    </footer>
				    </div>
				    <div className="fixed-bottom">
				    <div className="row justify-content-end">
				    <div className="col-sm-12 col-md-4">
				    <AlertExample />
				    </div>
				    </div>
			      	</div>
			      </div>

			);
	} else {

		return (
				<div className="bg-light">
					<div>
		 					<div className="row justify-content-center text-center bg-img1 align-items-center" style={{marginTop: 0}}>
				 				<div className="col-sm-12 col-md-8 col-lg-6" style={{marginTop: 0}}>
				 					
				    				<h3 className="display-4 text-light">Oh no! You have no matches with your partner</h3>
				    				
				    			
				  				</div>
				  			</div>
				  			
				  	</div>
					<main role="main" className="container" style={{marginTop: 80}}>
					<div className="row justify-content-center">
					<div className="col-sm-12 col-md-6">
					<p className="lead text-muted" style={{marginBottom: 40}}>Cheer up! These 15 items were just the tip of the iceberg. You can find lots more inspiration in the <a href="https://www.amazon.com/s/ref=lp_6110399011_fapo?rh=n%3A3760901%2Cn%3A%212334097011%2Cn%3A%212334159011%2Cn%3A6110399011&ie=UTF8&qid=1510304435&fap=1">Amazon sexual wellness couples guide.</a></p>
					</div>
					</div>
			      <div className="row justify-content-center">
					
			          { /* Render the list of messages */
			            this.state.results.map( result => (
			            	 

			            <div className="col-sm-12 col-md-6 col-lg-4" style={{marginTop: 15, marginBottom: 15}}>
			            <div className="card" key={result.id}>
			            	<h4 className="card-title text-muted" style={{marginBottom:"-20px", zIndex:'99', marginTop:10, marginRight:10, marginLeft:10, opacity:"0.8"}}><span className="float-right"><ModalExample description={result.description} buyLink={result.buyLink} cardTitle={result.title}/></span></h4>
			              <img id="image" className="card-img-top" src={result.src} alt="Card image cap" />
			              <div className="card-body">
			                <p className="card-title lead">{result.title}</p>
			                
			                <a href={result.buyLink} className="btn btn-block btn-lg btn-success">Buy Now!</a>
			              </div>
			            </div>
			            </div>
			      

			           ))
			          }
			        
					
					</div>
			      </main>
			      <footer className="text-muted bg-dark" style={{marginTop:50}}>

				      <div  style={{paddingTop:80, paddingBottom:40, paddingRight:20, paddingLeft:20}}>
				        <p className="float-right small">
				          <a href="http://www.louisnicholls.com" style={{color:'#c1c1c1'}}>&copy; Louis Nicholls 2017</a>
				          
				        </p>
				        <p className="float-left small">
				          <a href="https://unsplash.com/photos/AsahNlC0VhQ" style={{color:'#c1c1c1'}}>Photo by Everton Vila at Unsplash</a>
				          
				        </p>
				        
				      </div>
				    </footer>

			      </div>
			);

	}
}







}


class ModalExample extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    return (
      <div>
        <Button color="link" size="lg" onClick={this.toggle}><i className="fa fa-info-circle" aria-hidden="true"></i></Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>{this.props.cardTitle}</ModalHeader>
          <ModalBody>
            {this.props.description}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" href={this.props.buyLink}>Buy</Button>{' '}
            <Button color="secondary" onClick={this.toggle}>Close</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}







class AlertExample extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true
    };

    this.onDismiss = this.onDismiss.bind(this);
    

  }

  onDismiss() {
    this.setState({ visible: false });
  }


  render() {
  	
    return (
    	
    	
        	<Alert id="alert" color="info" isOpen={this.state.visible} toggle={this.onDismiss}>
        Don't forget to <a href="#share-results">share</a> with your partner!
      </Alert>
        
    
      
    );
  }
}




// WEBPACK FOOTER //
// ./src/Results.js